<script lang="ts" setup>
	import type { mediaType } from './camera.vue'

	defineProps<{
		btnText?: string
		format?: string
		cameraTip?: string
		uploadTip?: string
	}>()

	defineOptions({
		name: 'MediaUpload'
	})
	const emits = defineEmits<{
		(event: 'change', param: mediaType): void
	}>()
	const file = defineModel<mediaType | null>('file')
	const modelValue = defineModel<string | null>('value')
	const tabsList: lineTabContext[] = [
		{
			key: 'upload',
			name: 'Upload Photo'
		},
		{
			key: 'camera',
			name: 'Camera'
		}
	]
	const activeTab = shallowRef('upload')
	const photoProps = ref<mediaType>({
		blob: null,
		src: ''
	})
	const resetPhoto = () => {
		photoProps.value = {
			blob: null,
			src: ''
		}
	}
	const sendFile = () => {
		if (photoProps.value.src) {
			emits('change', photoProps.value || '')
			modelValue.value = photoProps.value?.src || ''
			file.value = photoProps.value || null
		}
	}
	onMounted(() => {
		if (file.value?.blob) {
			photoProps.value = {
				blob: file.value?.blob || null,
				src: String(file.value.src)
			}
		} else if (modelValue.value) {
			photoProps.value = {
				blob: null,
				src: String(modelValue.value)
			}
		}
	})
</script>

<template>
	<div>
		<tabs-line-tab
			v-model:active-tab="activeTab"
			:tabs="tabsList"
			:ui="{
				tab: {
					width: 'sm:min-w-[200px] min-w-[100px]',
					body: {
						default: 'flex overflow-x-auto justify-center w-full'
					}
				}
			}"
			query-key="upload-type"
			@selected="() => resetPhoto()"
		>
			<template #camera>
				<media-camera v-model:value="photoProps.src" v-model:file="photoProps" :tip="cameraTip" server-upload />
			</template>

			<template #upload>
				<media-upload
					v-model:value="photoProps.src"
					v-model:file="file"
					:tip="uploadTip"
					data-testid="file-upload"
					:format
					:server-upload="true"
				/>
			</template>

			<slot name="btn" :disabled="!photoProps.src" :process="sendFile">
				<div class="mt-12 flex flex-wrap items-stretch justify-between gap-3">
					<div class="w- flex-1">
						<slot name="cancel" />
					</div>

					<ui-button
						type="button"
						class="flex-1 justify-center bg-primary-2"
						:disabled="!photoProps.src"
						@click="sendFile"
					>
						{{ btnText }}
					</ui-button>
				</div>
			</slot>
		</tabs-line-tab>
	</div>
</template>
